const zh = {
  home: "首页",
  latestNews: "最新动态",
  photoGallery: "写真精选",
  videoWorks: "影视作品",
  fashionStyle: "时尚造型",
  fanSupport: "粉丝应援",
  aboutUs: "关于我们",
  viewAll: "查看全部",
  readMore: "阅读更多",
  subscribe: "订阅最新资讯",
  subscribeDesc: "第一时间获取佐佐木希最新动态、写真及独家内容",
  emailPlaceholder: "请输入您的邮箱地址",
  subscribeBtn: "立即订阅",
  subscribing: "订阅中...",
  subscribeSuccess: "订阅成功！感谢您的关注，我们将定期为您推送最新资讯。",
  subscribeError: "订阅失败，请稍后再试",
  networkError: "网络错误，请检查您的网络连接后重试",
  back: "返回",
  breadcrumbHome: "首页",
  exploreContent: "探索内容",
  exploreDesc: "发现关于佐佐木希的一切",
  disclaimer:
    "免责声明：本站为非官方粉丝资讯站，所有内容仅供粉丝交流使用。",
  followUs: "关注我们",
  followUsDesc: "获取佐佐木希最新动态与独家内容，请关注我们的社交媒体账号。",
};

export default zh;